/**
 * Format seconds to rounded minutes (e.g. "13 min").
 * Rounds up to the next full minute.
 */
export function formatSecondsAsMinutes(seconds: number): string {
  const minutes = Math.ceil(seconds / 60);
  return `${minutes.toLocaleString('de-DE')} min`;
}

/**
 * Format seconds to mm:ss (e.g. "12:34 Min").
 */
export function formatSecondsAsMmSs(seconds: number): string {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins.toLocaleString('de-DE')}:${String(secs).padStart(2, '0')} Min`;
}

/**
 * Convert seconds to billed minutes (ceil).
 */
export function secondsToBilledMinutes(seconds: number): number {
  return Math.ceil(seconds / 60);
}
